import { combineReducers } from '@reduxjs/toolkit';

import chatPreferences from './slices/chatPreferences';
import chatUnread from './slices/chatUnread';
import notifications from './slices/notifications';
import presence from './slices/presence';
import reminders from './slices/reminders';

const rootReducer = combineReducers({
  chatPreferences,
  chatUnread,
  notifications,
  presence,
  reminders,
});

export default rootReducer;
